import React from 'react';
import { InstaDataGrid } from 'components/common/grid';
import { GENERIC_TICKETS_PAGE_SIZE } from 'hooks/genericTickets/useGenericTicketsOperations';
import { URLS } from 'layouts/DrawerLayout/constants';

import useColumns from './useColumns';

const GenericTicketsGrid = ({
  loading,
  data,
  initialState,
  apiRef,
  total,
  page,
  pageSize,
  slots,
  slotProps,
  ...props
}) => {
  const columns = useColumns();

  return (
    <InstaDataGrid
      apiRef={apiRef}
      key={
        initialState
          ? `${JSON.stringify(initialState)}-grid-with-state`
          : 'grid-without-state'
      }
      initialState={initialState}
      loading={loading}
      columns={columns}
      rows={data || []}
      page={page}
      total={total}
      pageSize={pageSize}
      defaultPageSize={GENERIC_TICKETS_PAGE_SIZE}
      url={URLS.genericTickets}
      slots={slots}
      slotProps={slotProps}
      {...props}
    />
  );
};

export default GenericTicketsGrid;
